class YoutubeVideoPlayer extends HTMLElement {
  static apiReady = false;
  static apiPromise = null;
  static sectionPlayers = new Map();

  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    if (!this.originalContent) {
      this.originalContent = this.innerHTML;
    }

    this.playButton = this.querySelector(
      ".c-youtube-video-player__play-button",
    );

    if (this.playButton) {
      this.playButton.addEventListener("click", this.handleClick);
    }

    YoutubeVideoPlayer.loadAPI();
  }

  getSection() {
    return this.closest("section") || this.parentElement;
  }

  async handleClick() {
    const videoId = this.dataset.videoId;
    if (!videoId) return;

    await YoutubeVideoPlayer.loadAPI();

    this.renderPlayer(videoId);
  }

  renderPlayer(videoId) {
    if (this.player) {
      this.showPlayer();
      this.player.playVideo();
      return;
    }

    this.innerHTML = `
      <div class="c-youtube-cover">${this.originalContent}</div>
      <div class="c-youtube-player"></div>
    `;

    this.cover = this.querySelector(".c-youtube-cover");
    this.playButton = this.cover.querySelector(
      ".c-youtube-video-player__play-button",
    );
    this.playButton?.addEventListener("click", this.handleClick);

    const container = this.querySelector(".c-youtube-player");

    this.player = new YT.Player(container, {
      videoId,

      playerVars: {
        autoplay: 1,
        rel: 0,
        modestbranding: 1,
        playsinline: 1,
      },

      events: {
        onReady: (event) => {
          this.showPlayer();
          event.target.playVideo();
        },

        onStateChange: (event) => {
          const section = this.getSection();

          if (event.data === YT.PlayerState.PLAYING) {
            const active = YoutubeVideoPlayer.sectionPlayers.get(section);

            if (active && active !== this && active.player) {
              active.player.pauseVideo();
            }

            YoutubeVideoPlayer.sectionPlayers.set(section, this);

            this.showPlayer();
          }

          if (event.data === YT.PlayerState.PAUSED) {
            const currentTime = this.player.getCurrentTime();
            const duration = this.player.getDuration();

            if (duration && duration - currentTime > 0.8) {
              setTimeout(() => {
                if (
                  this.player &&
                  this.player.getPlayerState() === YT.PlayerState.PAUSED
                ) {
                  this.showCover();
                }
              }, 50);
            }
          }

          if (event.data === YT.PlayerState.ENDED) {
            this.showCover();
          }
        },
      },
    });
  }

  showCover() {
    if (this.cover) this.cover.style.display = "block";
    const player = this.querySelector(".c-youtube-player");
    if (player) player.style.display = "none";
  }

  showPlayer() {
    if (this.cover) this.cover.style.display = "none";
    const player = this.querySelector(".c-youtube-player");
    if (player) player.style.display = "block";
  }

  static loadAPI() {
    if (this.apiReady) return Promise.resolve();

    if (this.apiPromise) return this.apiPromise;

    this.apiPromise = new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = "https://www.youtube.com/iframe_api";
      script.async = true;
      document.head.appendChild(script);

      window.onYouTubeIframeAPIReady = () => {
        YoutubeVideoPlayer.apiReady = true;
        resolve();
      };
    });

    return this.apiPromise;
  }
}

if (!customElements.get("youtube-video-player")) {
  customElements.define("youtube-video-player", YoutubeVideoPlayer);
}
